import React from 'react'
import { Row,Col, Button } from 'antd';
import './index.less';
import {imgUrl} from '../../assets/404.svg';

export default class Nomatch extends React.Component {

    handleLink = ()=>{
        window.open(`/#/home`,'_self')
    }
    render() {
        return (
            <Row className="con">
                <Col span="12">
                    <div className="img-box">
                        <img src={imgUrl} alt=""/>
                    </div>
                </Col>
                <Col span="12" className="right">
                    <div className="text"><span>404</span>,<br/>抱歉，你访问的页面不存在</div>
                    <Button type="primary" onClick={this.handleLink}>回到首页</Button>
                </Col>
            </Row>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/nomatch/index.js